// Best-effort GTM dataLayer push. No-ops when GTM script isn't loaded
// (window.dataLayer is initialized by the GTM snippet in index.html).
export function pushDataLayer(event) {
  if (typeof window === 'undefined') return;
  if (!Array.isArray(window.dataLayer)) return;
  window.dataLayer.push(event);
}

export function trackPageview(path) {
  pushDataLayer({ event: 'pageview', page_path: path });
}
